import { createTheme, Theme } from '@mui/material/styles';

/**
 * Creates a custom theme for the MUI Switch component.
 *
 * @param {Theme} theme - The base theme to extend.
 * @returns {Theme} A new theme with custom Switch styles.
 */
export const DefaultSwitch = (theme: Theme) =>
  createTheme({
    components: {
      MuiSwitch: {
        styleOverrides: {
          // Styles for the root element of the Switch
          root: {
            width: 36,
            height: 20,
            padding: 0,
            marginRight: '8px',
          },
          // Styles for the base of the switch (the clickable area)
          switchBase: () => ({
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            // Styles when the switch is checked
            '&.Mui-checked': {
              transform: 'translateX(16px)',
              color: '#fff',
              '& + .MuiSwitch-track': {
                backgroundColor: '#2B3493',
                opacity: 1,
                border: 0,
              },
              '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
              },
            },
            // Styles when the switch is focused
            '&.Mui-focusVisible .MuiSwitch-thumb': {
              color: '#33cf4d',
              border: '6px solid #fff',
            },
            // Styles when the switch is disabled
            '&.Mui-disabled .MuiSwitch-thumb': {
              color:
                theme.palette.mode === 'light'
                  ? theme.palette.grey[100]
                  : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
            },
          }),
          // Styles for the thumb (the moving part) of the switch
          thumb: {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
          },
          // Styles for the track (the background) of the switch
          track: () => ({
            borderRadius: 26 / 2,
            backgroundColor:
              theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
              duration: 500,
            }),
          }),
        },
      },
    },
  });
